/* Replace only Globo's numeric collection-label fallbacks with Shopify titles. */
(() => {
  function start() {
    const source = document.getElementById('ll-collection-filter-names');
    if (!source) return;
    const names = new Map([...source.querySelectorAll('[data-collection-id]')]
      .map(e => [e.dataset.collectionId, e.textContent.trim()]));
    const target = document.getElementById('CollectionAjaxContent') || document.body;
    function repair() {
      target.querySelectorAll('[data-filter-type="Collection"] [data-fvalue], [data-fhandle="collection"][data-fvalue]').forEach(button => {
        const id = button.dataset.fvalue, title = names.get(id);
        const label = button.querySelector('.gf-label');
        if (title && label?.textContent.trim() === id) {
          label.textContent = title;
          button.setAttribute('aria-label', (button.dataset.fhandle === 'collection' ? 'Remove filter value: ' : '') + title);
        }
      });
    }
    let timer;
    new MutationObserver(() => {
      clearTimeout(timer); timer = setTimeout(repair, 80);
    }).observe(target, {childList:true, subtree:true, characterData:true});
    repair();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
